<template>
  <div>
    <div class="dd-background ">
      <i :class="`fas fa-${backgroundIcon} fa-2 bg-icon secondary--text animated zoomIn`" v-if="backgroundIcon"></i>
    </div>
    <!-- <div class="bensu-watermark">
      <i class="fa fa-map-marker"></i>
    </div> -->
  </div>


</template>
<script>
  import * as types from "../../store/types"
  import { mapGetters } from 'vuex'

  export default{
    computed:{
      ...mapGetters({
        backgroundIcon: types.BACKGROUND_ICON
      })
    },
  }
</script>
<style>

  .dd-background{
    top: 0;
    bottom: 0;
    width: 100%;
    position: fixed;
    background-color: #fff;
    opacity:1;
    /* background-size: cover;
    background-position: center top;
    background-attachment: fixed; */
    z-index:1;
    min-height: calc(100vh - 80px);



  }

  .bg-icon{
    font-size: calc(40vh);
    position: fixed;
    bottom:0;
    margin-bottom: 40px;
    right:0;    
     background: -webkit-linear-gradient(-45deg, #fff, #ccc );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
    opacity: .3;
  }

  /* .dd-background{
    top: 0;
    bottom: 0;
    width: 100%;
    position: fixed;
    background-image: url('../../assets/images/bg2.jpg');
    opacity:.1;
    background-size: cover;
    background-position: center top;
    background-attachment: fixed;
    z-index:1;
    min-height: calc(100vh - 80px);

  } */

</style>
